import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    pageContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        [theme.breakpoints.between('sm', 'md')]: {
            mt:{sm:'75px', lg:'auto'}
        }
    },
    topImage: {
        height: '120px',
        marginBottom: '20px',
        objectFit: 'cover',
        [theme.breakpoints.down('sm')]: {
            height: '90px',
            marginTop:'50px',
        },
    },
    cardsContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        width: '85%',
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
    },
    card: {
        width: '23%',
        margin:'20px',
        border:'1px solid #ff6468ff',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
        borderRadius: '20px !important',
        textAlign: 'center',
        color: '#fff',
        transition: 'transform 0.2s ease-in-out',
        '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: '0px 6px 18px rgba(0, 0, 0, 0.2)',
            cursor:'pointer',
        },
        [theme.breakpoints.down('xs')]: {
            width: '90% !important',
        },
        [theme.breakpoints.up('md')]: {
            width: '35%',
            margin:'10px',
        },
        [theme.breakpoints.down('lg')]: {
            width: '35%',
        },
    },
    cardImage: {
        marginTop:'20px',
        height: '60px',
        maxWidth: '100%',
        objectFit: 'contain',
        borderTopLeftRadius: '10px',
        borderTopRightRadius: '10px',
        [theme.breakpoints.down('sm')]: {
            height: '50px',
        },
    },
    cardText: {
        color:'#ff6468ff',
        padding:'24px 20px 0px 20px',
        fontSize:'32px !important',
        lineHeight:'1.2 !important',
    },
    cardContent: {
        padding: '0px !important',
        color: '#fff',
    },
    cardHeader:{
        width: '100%',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'flex-start',
        paddingTop:'20px',
        height: '200px',
        background: 'linear-gradient(to bottom right, #6A8EC9 0%, #8C74A7 30%, #D44C71 66%, #C91C6E 103%)',
        borderBottomLeftRadius: '100% 50px',
        borderBottomRightRadius: '100% 50px',
        overflow: 'hidden',
        position: 'relative',
    },
    listItemText: {
        color:'#5A5A5A',
        textAlign:'left',
        fontSize:'1rem',
        paddingRight:'10px',
        paddingBottom:'15px',
    },
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        fontSize: '45px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: "32px !important",
        },
    },
    subtitle: {
        color: '#ff6468 !important',
        fontWeight: 'regular !important',
        textAlign: 'center',
        fontSize: '35px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: "28px !important",
        },
    },
    cardButton:{
        backgroundColor:'#ff6468ff',
        color:'#fff',
        marginBottom:'55px',
        '&:hover': {
            cursor:'pointer',
            backgroundColor:'#ff6468ff',
            color:'#fff',
        },
    },
    table:{
        backgroundColor:'#fff',
    },
    tableHeader: {
        backgroundColor: '#ed6728ff !important',
    },
    tableHeaderCell: {
        fontSize: '17px',
        fontWeight: 500,
        color:'#fff !important',
        textAlign:'center !important',
    },
    tableCell:{
        padding:'4px 20px !important',
        borderRight: '1px solid #ccc',
        // color:'#000000',
        fontSize:'13px',
    },
    topicCell: {
        textAlign: 'center',
        verticalAlign: 'middle',
    },
    button:{
        padding: '10px 50px',
        fontWeight: 'bold',
        fontSize: '16px',
        borderRadius: '13px',
        color:'#fff !important',
        backgroundColor: '#ff6468ff',
        '&:hover': {
            backgroundColor: '#ff6468ff !important',
        },
    },
    popupButton:{
        width: '70%',
        alignSelf: 'center',
        fontWeight: 'bold',
        fontSize: '17px !important',
        borderRadius: '20px !important',
        color:'#fff !important',
        backgroundColor: '#FF6900 !important',
        '&:hover': {
            backgroundColor: '#e55e00 !important',
        },
    },
    tableContainer: {
        margin: theme.spacing(2, 0),
        overflowX: 'auto',
    },
    editIcon: {
        fontSize: 18,
        cursor: 'pointer',
        color: '#ff6468ff !important',
    },
}));

export default useStyles;